import { PropTypes } from "prop-types"
import classNames from "classnames"

import InputPassword from "./InputPassword"
import Field from "../Field"
import fieldSchemaPropTypes from "../fieldSchemaPropTypes"
import errorPropTypes from "../errorPropTypes"

export function PasswordField(props) {
  const {
    className,
    error,
    id,
    label,
    labelId,
    name,
    schema,
    onChange,
    isClearable = true,
    touched = false,
    ...rest
  } = props
  const handleChange = e => onChange(name, e.target.value)
  const handleClear = () => onChange(name, "")

  return (
    <Field className={classNames("oj-password-field", className)} touched={touched} error={error}>
      <Field.Label id={labelId} inputId={id} label={label} required={schema.required}>
        <Field.Input
          {...schema}
          {...rest}
          isClearable={isClearable}
          id={id}
          error={error}
          name={name}
          onClear={handleClear}
        >
          {innerProps => <InputPassword {...innerProps} onChange={handleChange} />}
        </Field.Input>
      </Field.Label>
    </Field>
  )
}

PasswordField.propTypes = {
  className: PropTypes.string,
  error: PropTypes.shape(errorPropTypes),
  isClearable: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.node,
  labelId: PropTypes.string,
  name: PropTypes.string.isRequired,
  schema: PropTypes.shape(fieldSchemaPropTypes),
  onChange: PropTypes.func.isRequired,
  touched: PropTypes.bool
}

export default PasswordField
